<template>
  <div class="lx-toolbar" role="group" aria-label="Forecast controls">
    <div class="lx-country">
      <label class="lx-sr-only" for="mtf-country">Country</label>
      <!-- Vuetify 3.0.0-beta.0: items are plain strings, the model is the string -->
      <v-select
        id="mtf-country"
        :items="countryNames"
        :model-value="modelValue && modelValue.name"
        density="compact"
        variant="outlined"
        hide-details
        :disabled="loading"
        aria-label="Country"
        class="lx-select"
        @update:model-value="onSelect"
      ></v-select>
    </div>

    <v-switch
      :model-value="endogenous"
      color="primary"
      hide-details
      density="compact"
      class="lx-switch"
      label="Endogenize SPX"
      :aria-label="endogenous ? 'S&P 500 is endogenous (forecast by the model)' : 'S&P 500 is exogenous (taken from the input table)'"
      @update:model-value="$emit('update:endogenous', !!$event)"
    ></v-switch>

    <div class="lx-badges" aria-label="Data and model metadata">
      <span class="lx-badge" :class="{ 'lx-badge--missing': !meta.dataAsOf }">
        <span class="lx-badge__k">Data as of</span>
        <span class="lx-badge__v">{{ meta.dataAsOf || "not provided" }}</span>
      </span>
      <span class="lx-badge" :class="{ 'lx-badge--missing': !meta.modelEstimatedAt }">
        <span class="lx-badge__k">Model estimated</span>
        <span class="lx-badge__v">{{ meta.modelEstimatedAt || "not provided" }}</span>
      </span>
      <span class="lx-badge" :class="{ 'lx-badge--missing': !meta.modelVariant }">
        <span class="lx-badge__k">Variant</span>
        <span class="lx-badge__v">{{ meta.modelVariant || "not provided" }}</span>
      </span>
      <span class="lx-badge">
        <span class="lx-badge__k">Horizon</span>
        <span class="lx-badge__v">{{ meta.horizonWeeks || 52 }} weeks</span>
      </span>
      <span v-if="meta.illustrative" class="lx-badge lx-badge--illustrative">
        <span class="lx-badge__k">Source</span>
        <span class="lx-badge__v">illustrative fixtures</span>
      </span>
    </div>

    <div class="lx-toolbar__spacer"></div>
    <button type="button" class="lx-btn" :disabled="loading" aria-label="Reload consensus table" title="Reload the consensus table (discards edits)" @click="$emit('reload')">
      <v-icon size="16">mdi-reload</v-icon> Reload
    </button>
  </div>
</template>

<script>
export default {
  name: "ForecastControls",
  props: {
    countries: { type: Array, default: () => [] },
    modelValue: { type: Object, default: null },
    endogenous: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    meta: { type: Object, default: () => ({}) },
  },
  emits: ["update:modelValue", "update:endogenous", "reload"],
  computed: {
    countryNames() {
      return this.countries.map((c) => c.name);
    },
  },
  methods: {
    onSelect(name) {
      const c = this.countries.find((x) => x.name === name);
      if (c) this.$emit("update:modelValue", c);
    },
  },
};
</script>

<style scoped>
.lx-country { min-width: 220px; }
.lx-switch { margin: 0; }
</style>
